<template>
  <div class="wrapper">
    <div class="breadcrumb">
      {{$t("join.position.breadcrumb")}} -
      <el-popover placement="top-start" width="610" trigger="click" class="content" id="btnBox">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" class="content"
                 v-loading="loading"
                 :element-loading-text="$t('join.position.sending')"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="boxTop">
            <div class="left">
              <el-form-item :label="$t('join.position.name')" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('join.position.mobile')" prop="mobile">
                <el-input v-model.number="ruleForm.mobile" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('join.position.levelWord')" prop="levelWord" class="position-textarea">
                <el-input v-model="ruleForm.levelWord" placeholder="" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item :label="$t('join.position.position')" prop="position">
                <el-select v-model="ruleForm.position" clearable :placeholder="$t('join.position.select')">
                  <el-option v-for="item in getLang === 'zh' ? zhPositions : twPositions" :key="item.id" :value="item" @click.native="setEmail()"></el-option>
                </el-select>
              </el-form-item>
              <!--<el-form-item :label="$t('join.position.sengdEmail')" prop="email">
                <el-select v-model="ruleForm.email" clearable :placeholder="$t('join.position.select')">
                  <el-option :value="getLang === 'zh' ? this.zhEmail.get(this.ruleForm.position) : this.twEmail.get(this.ruleForm.position)"></el-option>
                </el-select>
              </el-form-item>-->
              <el-form-item :label="$t('join.position.path')" prop="path" ref="pathForm">
                <el-upload
                  class="upload-demo"
                  action="https://www.sfkp.cn/api/file/resume"
                  v-model.number="ruleForm.mobile"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  :before-remove="beforeRemove"
                  :before-upload="beforeAvatarUpload"
                  multiple
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList">
                  <el-button size="small" type="" class="btnGreen">{{$t('join.position.path')}}</el-button>
                  <div slot="tip" class="el-upload__tip">{{$t('join.position.uploadTip')}}</div>
                </el-upload>
              </el-form-item>
            </div>
          </div>
          <el-form-item class="btngroup">
            <el-button @click="submitForm('ruleForm')" type="primary">{{$t('join.position.submit')}}</el-button>
            <el-button @click="resetForm('ruleForm')" class="btnNone">{{$t('join.position.reset')}}</el-button>
          </el-form-item>
        </el-form>
        <el-button slot="reference" type="text" class="popups">
          <a class="email">{{$t("join.position.email")}}<i class="iconfont icon-email"></i></a>
        </el-button>
      </el-popover>
    </div>
    <div class="container position">
      <div class="title">{{$t("join.position.title")}}</div>
      <div class="items">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item v-for="item in positionList" :key="item.id" :title="getLang === 'zh' ? item.position : item.fantiPosition" :name="item.id">
            <div class="des">
              <p>{{$t("join.position.duty")}}：</p><br/>
              <p class="text" v-html="getLang === 'zh' ? item.duty : item.fantiDuty"></p>
              <br/>
              <p>{{$t("join.position.des")}}：</p><br/>
              <p class="text" v-html="getLang === 'zh' ? item.positionRequirements : item.fantiPositionRequirements"></p>
              <br/>
              <p class="pay">{{$t("join.position.pay")}}：{{item.minPay}} - {{item.maxPay}}{{$t("join.position.yuan")}}</p>
              <p class="person">{{$t("join.position.person")}}：{{item.person}}{{$t("join.position.ren")}}</p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinStatement',
  data () {
    return {
      activeName: '1',
      positionList: [],
      zhPositions: [],
      twPositions: [],
      defaultList: [
        {
          id: '201903211732329937213',
          updateTime: '2019-03-22 16:38:39',
          createdTime: '2019-03-21 17:32:32',
          position: '城中村改造主管',
          duty: '1、负责项目镇街、村民等关系维护。\n2、负责项目改造各阶段（测量、民意征询、改造方案、签约等）工作推进。\n3、对接政府的规划、建设、更新等建设相关的部门。',
          email: 'sherrysun@sfk.cn',
          fantiduty: '1、負責項目鎮街、村民等關係維護。\n2、負責項目改造各階段（測量、民意徵詢、改造方案、簽約等）工作推進。\n3、對接政府的規劃、建設、更新等建設相關的部門。',
          fantiPosition: '城中村改造主管',
          positionRequirements: '1、全日制大专以上学历，房地产及建筑工程类相关专业背景。\n2、3年以上城中村改造及相关行业从业经验，具备广州本地国土、规划、更新等部门或知名地产经验者优先考虑。\n3、熟悉城市更新项目土地一级开发拓展经验，熟悉城市更新项目操作流程，具备较强的政府关系及公关能力。\n4、形象气质佳、沟通表达好，逻辑思维清晰，能承受较强的工作压力。\n5、熟悉日常办公软件操作及一定的写作、公文处理能力。\n\n上班地址：1、钟落潭镇钟升东路钟升酒店6楼601    周边地铁站：钟落潭（1人）\n                 2、广州市白云区人和镇西湖村西湖西街（1人）',
          fantipositionRequirements: '1、全日制大專以上學曆，房地產及建築工程類相關專業背景。\n2、3年以上城中村改造及相關行業從業經驗，具備廣州本地國土、規劃、更新等部門或知名地產經驗者優先考慮。\n3、熟悉城市更新項目土地一級開發拓展經驗，熟悉城市更新項目操作流程，具備較強的政府關係及公關能力。\n4、形象氣質佳、溝通表達好，邏輯思維清晰，能承受較強的工作壓力。\n5、熟悉日常辦公軟體操作及一定的寫作、公文處理能力。\n\n上班地址：1、鐘落潭鎮鐘升東路鐘升酒店6樓601    周邊地鐵站：鐘落潭（1人）\n                 2、廣州市白雲區人和鎮西湖村西湖西街（1人）',
          creator: '13560051057',
          updator: '13560051057',
          minPay: '7000.0',
          maxPay: '9000.0',
          person: '2'
        },
        {
          id: '201903211735561256379',
          updateTime: '2019-03-22 16:39:05',
          createdTime: '2019-03-21 17:35:56',
          position: '开发助理',
          duty: '1、协助开发经理开展各项前期手续的报批，工程建设过程中的各类报批报建配套工作,工程竣工验收；\n2、配合公司办理有关涉及政府关系、现场周边关系的协调，及时收集、整理、研究报批报建政策；\n3、负责建立、维护与政府及相关部门的良好关系，确保各项手续办理的顺利进行。',
          email: 'sherrysun@sfk.cn',
          fantiduty: '1、協助開發經理開展各項前期手續的報批，工程建設過程中的各類報批報建配套工作,工程竣工驗收；\n2、配合公司辦理有關涉及政府關係、現場周邊關係的協調，及時收集、整理、研究報批報建政策；\n3、負責建立、維護與政府及相關部門的良好關係，確保各項手續辦理的順利進行。',
          fantiPosition: '開發助理',
          positionRequirements: '1、大专及以上学历，专业不限；\n2、性格开朗，具备较强的沟通协调能力；\n3、熟悉word、excel、PPT等常用办公软件；\n4、具有宣传、推广、策划及组织活动经验优先考虑。\n\n\n\n上班地址：1、钟落潭镇钟升东路钟升酒店6楼601    周边地铁站：钟落潭（1人）\n                 2、广州市白云区人和镇西湖村西湖西街（1人）',
          fantipositionRequirements: '1、大專及以上學曆，專業不限；\n2、性格開朗，具備較強的溝通協調能力；\n3、熟悉word、excel、PPT等常用辦公軟體；\n4、具有宣傳、推廣、策劃及組織活動經驗優先考慮。\n\n\n\n上班地址：1、鐘落潭鎮鐘升東路鐘升酒店6樓601    周邊地鐵站：鐘落潭（1人）\n                 2、廣州市白雲區人和鎮西湖村西湖西街（1人）',
          creator: '13560051057',
          updator: '13560051057',
          minPay: '4000.0',
          maxPay: '6000.0',
          person: '2'
        },
        {
          id: '201903211737459471809',
          updateTime: '2019-03-22 16:40:03',
          createdTime: '2019-03-21 17:37:45',
          position: '造价工程师',
          duty: '1、负责土建工程的预结算工作，熟悉土建工程预算；\n2、做过商住楼的土建工程相应的预算或结算工程；\n3、能独立、快速、准确地编制和审核工程预结算；\n\n4、负责对设计估算、施工图预算、招标文件编制、工程量计算等进行计算和审核；\n\n5、公司领导交办的其他与工程管理相关的工作。',
          email: 'sherrysun@sfk.cn',
          fantiduty: '1、負責土建工程的預結算工作，熟悉土建工程預算；\n2、做過商住樓的土建工程相應的預算或結算工程；\n3、能獨立、快速、準確地編製和審核工程預結算；\n\n4、負責對設計估算、施工圖預算、招標檔案編製、工程量計算等進行計算和審核；\n\n5、公司領導交辦的其他與工程管理相關的工作。',
          fantiPosition: '造價工程師',
          positionRequirements: '1、工程造价、土建预算管理工程类等相关专业大专及以上学历；\n2、接受过造价成本控制管理、法律基础、合同管理等培训； \n3、3年以上土建或机电预算结算工作经验； \n4、熟练操作office、CAD、广联达等办公和算量软件；\n5、性格稳重，细心，严谨务实；有较高的职业操守。\n6、工作地址：广州市白云区江高镇江府路',
          fantipositionRequirements: '1、工程造價、土建預算管理工程類等相關專業大專及以上學曆；\n2、接受過造價成本控制管理、法律基礎、合同管理等培訓； \n3、3年以上土建或機電預算結算工作經驗； \n4、熟練操作office、CAD、廣聯達等辦公和算量軟體；\n5、性格穩重，細心，嚴謹務實；有較高的職業操守。\n6、工作地址：廣州市白雲區江高鎮江府路',
          creator: '13560051057',
          updator: '13560051057',
          minPay: '7000.0',
          maxPay: '10000.0',
          person: '1'
        }
      ],
      ruleForm: {
        name: '',
        mobile: '',
        levelWord: '',
        position: '',
        path: '',
        email: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '电话不能为空' },
          { type: 'number', message: '电话必须为数字值' }
        ],
        path: [
          { required: true, message: '附件未上传' }
        ],
        position: [
          { required: true, message: '职位未选择' }
        ],
        email: [
          { required: true, message: '职位或邮箱未选择' }
        ]
      },
      fileList: [],
      loading: false,
      zhEmail: '',
      twEmail: ''
    }
  },
  mounted () {
  },
  created () {
    // this.$axios.get('http://localhost:8088/api/xinfugang/recruit/list')
    this.$axios.get('https://www.sfkp.cn/api/xinfugang/recruit/list')
    // this.$axios.get('http://223.4.157.105:8081/api/xinfugang/recruit/list')
      .then(res => {
        // document.getElementById('btnBox').style.display = 'block'
        // 连接成功后对数据长度<=0的情况下
        if (res.data.data.length < 0) {
          this.$message({
            message: '获取新闻数量为0，请检查后台是否正确上传招聘岗位内容！',
            type: 'warning'
          })
          this.positionList = this.defaultList
          this.positionEmail()
          return false
        }
        // 连接成功后对数据长度>0的情况下
        this.positionList = res.data.data
        this.positionEmail()
        console.log(this.positionList)
      })
      .catch(error => {
        // document.getElementById('btnBox').style.display = 'none'
        this.positionList = this.defaultList
        this.positionEmail()
        this.$message({
          message: '网络连接失败，请检查网络状况，或稍后再试！',
          type: 'warning'
        })
        console.log(error)
      })
  },
  computed: {
    getLang () {
      return this.$store.state.lang
    }
  },
  methods: {
    // 上传成功后，返回结果集
    handleAvatarSuccess (res, file) {
      this.ruleForm.path = file.response.data.fileName
    },
    // 上传后文件列表操作
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 上传文件前校验并处理
    beforeAvatarUpload (file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isDoc = fileType === 'doc'
      const isDocx = fileType === 'docx'
      const minSize = file.size / 1024 / 1024 < 5
      if (!isDoc && !isDocx) {
        this.$message({
          message: '上传文件只能是 doc、docx格式!',
          type: 'warning'
        })
      }
      if (!minSize) {
        this.$message({
          message: '文件大小不能超过5mb!',
          type: 'warning'
        })
      }
      this.cancelFieldValidate('pathForm')
      return isDoc || isDocx
    },
    // 提交表单，验证
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.ruleForm.path) {
          this.loading = !this.loading
          let postData = this.$qs.stringify(this.ruleForm)
          const that = this
          this.$axios({
            method: 'post',
            // url: 'http://localhost:8088/api/xinfugang/sendEmail',
            url: 'https://www.sfkp.cn/api/xinfugang/sendEmail',
            // url: 'http://223.4.157.105:8081/api/xinfugang/sendEmail',
            data: postData,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
            .then((response) => {
              console.log(response)
              that.$message({
                message: '发送成功！',
                type: 'success'
              })
              // 清空数据，关闭面板
              this.resetForm(formName)
              this.fileList = []
              this.loading = !this.loading
              document.getElementById('app').click()
            })
            .catch((error) => {
              console.log(error)
              that.$message({
                message: '发送失败，请检查网络状况！',
                type: 'warning'
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 重置全部表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.fileList = []
    },
    // 去除指定元素的验证警告
    cancelFieldValidate (item) {
      this.$refs[item].clearValidate()
    },
    // 获取岗位名称及邮箱
    positionEmail () {
      let zhMap = new Map()
      let twMap = new Map()
      for (let item of this.positionList) {
        this.zhPositions.push(item.position)
        this.twPositions.push(item.fantiPosition)
        zhMap.set(item.position, item.email)
        twMap.set(item.fantiPosition, item.email)
      }
      this.zhEmail = zhMap
      this.twEmail = twMap
    },
    setEmail () {
      let email = this.getLang === 'zh' ? this.zhEmail.get(this.ruleForm.position) : this.twEmail.get(this.ruleForm.position)
      this.ruleForm.email = email
      // console.log(this.ruleForm)
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      .content
        .email
          &:hover
            color $navBgColor
          color $navBgHoverColor
        i
          margin-left 5px
    .container
      box-sizing border-box
      padding 0 23px
      letter-spacing 0.15px
      .title
        cn()
        font-weight bold
        margin-bottom 40px
        line-height 28px
      .des
        box-sizing border-box
        padding 25px 32px 0
        .text
          white-space pre-wrap
          word-wrap break-word
          line-height 26px
          padding-left 15px
          box-sizing border-box
        .pay
          margin-top 20px
  .boxTop
    display flex
    width 100%
    padding-top 15px
    .left
      width 50%
    .right
      width 50%
  .btngroup
    width 100%
    text-align center
  .message
    label
      padding-left 10px!important
  .btnGreen
    btnGreen()
    &:hover
      btnGreenHover()
  .btnNone
    &:hover
      btnGreenHover()
    &:focus,&:active
      background #FFF!important
      color #000!important
</style>



// WEBPACK FOOTER //
// src/pages/join/components/Position.vue